import { DocumentData, DocumentReference, doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase/config';

export const safeGetDoc = async <T extends DocumentData>(
  docRef: DocumentReference<T>,
  retries = 3,
  delay = 1000,
  errorMessage: string = 'Document not found'
): Promise<T | null> => {
  let attempts = 0;

  while (attempts < retries) {
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return docSnap.data();
      }
      return null;
    } catch (error) {
      attempts++;
      if (attempts === retries) {
        console.error(errorMessage, 'after', retries, 'attempts:', error);
        throw error;
      }
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }

  return null;
};

export const getUserDoc = async (uid: string) => {
  const userRef = doc(db, 'users', uid);
  return safeGetDoc(userRef);
};